export const LOG_IN = ({ commit, dispatch, getters }) => {
  commit('SET_LOGGED_IN_STATE')
}

export const LOG_OUT = ({ commit, dispatch }) => {
  dispatch('disconect', { shouldReconnect: false })
  commit('SET_LOGGED_OUT_STATE')
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js